import PropTypes from 'prop-types';
import React from 'react';
import Translation from '../../../containers/i18n/Translation';
import Button from '../../common/Button';

const CashInConfirm = ({ price, confirm, reject, requestPending }) => (
  <div className="modal">
    <div>
      <h2 className="modal__header">
        <Translation section="cashInConfirm" label="title" variables={{ price }} />
      </h2>
      <p className="modal__paragraph">
        <Translation section="cashInConfirm" label="question" variables={{ price }} />
      </p>
      {
        !requestPending ? (
          <div className="modal__button-line">
            <Button className="modal__button" onClick={confirm}>
              <Translation section="common" label="yes" />
            </Button>
            <Button className="modal__button" onClick={reject}>
              <Translation section="common" label="no" />
            </Button>
          </div>
        ) : null
      }
    </div>
  </div>
);

CashInConfirm.propTypes = {
  price: PropTypes.string,
  confirm: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired,
  requestPending: PropTypes.bool.isRequired
};

export default CashInConfirm;
